import React, { useContext, useEffect, useState } from 'react';
import LeaveStatusChart from "./leave-status-chart";
import server from "../../../server";
import {IEmployeeLeaveStatus, LeavePeriod} from "./types/leave-status-types";
import StatsChart from "../../common/stats-chart/stats-chart";
import {BarChart2} from "lucide-react";
import {useNavigate} from 'react-router-dom';
import UserLoginContext from "../../../context/userLoginContext";

const EmployeeLeaveSummary = () => {
    const {user}=useContext(UserLoginContext);
    const [leaveStatusData, setLeaveStatusData] = useState<IEmployeeLeaveStatus[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate=useNavigate();

    const handleOnClick = () => {
        navigate('/time-off/leaves/summary')
    }

    useEffect(() => {
        fetchLeavePeriod();
    }, []);

    async function fetchLeavePeriod() {
        try {
            const leavePeriods: LeavePeriod[] = await server.leave.period.list();
            const today = new Date();
            const currentLeavePeriod = leavePeriods.find((period) => {
                const start = new Date(period.startDate);
                const end = new Date(period.endDate);
                return today >= start && today <= end;
            });

            if (currentLeavePeriod) {
                fetchLeaveStatusData(currentLeavePeriod.id);
            }

        } catch (e) {
            console.log("Error while fetching leave period", e);
        }
    }

    async function fetchLeaveStatusData(leavePeriodId: any) {
        setLoading(true);
        try {
            const payload = {
                leavePeriodId: leavePeriodId,
                employeeId: user.employeeId
            }

            const status: IEmployeeLeaveStatus[] = await server.leave.balance.getById(payload);
            setLeaveStatusData(status);
        } catch (e) {
            console.log("Error while fetching leave status data", e);
        } finally {
            setLoading(false)
        }
    }

    return (
        <StatsChart
            icon={BarChart2}
            title={"My Leave Status Analysis"}
            badge={{
                text: leaveStatusData?.[0]?.leaves?.[0]?.balance
                    ? `Leave Balance: ${leaveStatusData[0].leaves[0].balance}`
                    : "",
                color: "red"
            }}
            subtitle={'Your leave summary for this year.'}
            onClick={handleOnClick}
            className={'dashboard-employee-leave-card'}
        >
            <LeaveStatusChart leaveStatusData={leaveStatusData} loading={loading}/>
        </StatsChart>
    )
}

export default EmployeeLeaveSummary;
